import React, { Component } from 'react';
import { Helmet }           from 'react-helmet';
import AppRouter            from './AppRouter';
import Authenticate         from './framework/Authenticate';
import TenantProvider       from './framework/TenantProvider'
import UserGate             from './framework/UserGate';


import '../scss/app.scss';
import '../lib/navigation.css';


class App extends Component {
    render() {
        return (
            <React.Fragment>
                <Authenticate/>
                <UserGate>
                    <TenantProvider>
                        <Helmet>
                            <title>Restaurant Capabilities</title>
                        </Helmet>

                        <AppRouter/>
                    </TenantProvider>
                </UserGate>
            </React.Fragment>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// /src/components/App.js